import React from 'react'
import { Link } from 'react-router-dom'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import PublicLandingInquiryForm from '../../marketing/PublicLandingInquiryForm'
import { LANDING_PATH } from '../../marketing/marketingNav'

const CONTACT_EMAIL = 'support@sgez.co.kr'
const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('[설계EZ] 도입 문의')}`

export default function PublicInquiryPage() {
  return (
    <MarketingSiteLayout>
      <div id="inquiry-page-top" className="border-b border-slate-100 bg-gradient-to-b from-slate-50 to-white">
        <div className="mx-auto max-w-6xl px-4 py-10 md:py-14">
          <nav className="text-sm text-slate-500">
            <Link to={LANDING_PATH} className="hover:text-brand-navy">
              홈
            </Link>
            <span className="mx-2">/</span>
            <span className="text-slate-800">문의하기</span>
          </nav>
          <h1 className="mt-4 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl md:text-5xl">도입·이용 문의</h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
            아래 폼을 남겨 주시면 운영관리 고객문의로 접수되고, 운영자 알림으로 빠르게 전달돼요. 요금·기능·도입 절차 등 편하게 적어 주세요.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-12 md:py-16">
        <div className="grid gap-12 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16">
          <aside className="min-w-0 space-y-8">
            <div className="rounded-2xl border border-slate-200 bg-slate-50/80 p-6 text-sm text-slate-700">
              <div className="text-xs font-bold tracking-widest text-brand-sky">고객센터</div>
              <p className="mt-3 text-base font-semibold text-slate-900">평일 09:00 – 18:00 (공휴일 제외)</p>
              <p className="mt-2">
                이메일{' '}
                <a className="font-semibold text-brand-navy underline-offset-2 hover:underline" href={CONTACT_MAILTO}>
                  {CONTACT_EMAIL}
                </a>
              </p>
              <p className="mt-2 text-xs text-slate-500">급한 연락처는 도입 확정 후 별도 안내드릴 수 있어요.</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-6 text-sm leading-7 text-slate-600">
              <div className="font-semibold text-slate-900">접수 후 흐름</div>
              <ol className="mt-3 list-decimal space-y-1 pl-5">
                <li>이 페이지에서 문의 접수</li>
                <li>운영관리 &gt; 고객문의에 기록</li>
                <li>운영자 웹 알림</li>
                <li>고객문의 상세에서 답변</li>
              </ol>
            </div>
            <p className="text-xs text-slate-500">
              이미 계정이 있으시면{' '}
              <Link to="/support/inquiries" className="font-semibold text-brand-navy hover:underline">
                로그인 후 고객문의
              </Link>
              에서 비공개 문의도 이용하실 수 있어요.
            </p>
          </aside>

          <div className="min-w-0 rounded-[28px] border border-slate-200 bg-white p-8 shadow-xl shadow-slate-200/50 sm:p-10">
            <PublicLandingInquiryForm scrollIntoViewOnSuccessId="inquiry-page-top" />
          </div>
        </div>
      </div>
    </MarketingSiteLayout>
  )
}
